import '@york/ui/content.css';

import './globals.css';

import { StrictMode } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { createRoot } from 'react-dom/client';

import { routeTree } from './routeTree.gen.ts';
import { useAuth } from './store/auth.ts';

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// 读取保持新鲜 5 秒，重试一次，窗口/标签页重新聚焦时重新获取，
// 使 UI 在用户返回页面后不久获取到其他地方的变更（如管理区课程编辑）。
// 注意：用户在页面上空闲时不会自动刷新——staleTime 仅在
// 重新挂载/重新聚焦时触发，没有轮询。
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

// 首次渲染前从 httpOnly cookie 水合认证状态，使路由守卫
// （beforeLoad）读取已确定的用户而非瞬态 null → 无误重定向。
await useAuth.getState().hydrate();

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
